import 'react-native-get-random-values'

import { debounce, orderBy, uniqBy } from 'lodash'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { ImageBackground, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { FlatList, ScrollView, Switch } from 'react-native-gesture-handler'
import { List, Menu, Modal } from 'react-native-paper'

import Clipboard from '@react-native-clipboard/clipboard'

import image from '../../../assets/icons/Home_Purple.png'
import { Text } from '../../components'
import { translate } from '../../i18n'
import { useStore } from '../../models'
import styles from '../../styles/globalStyle'
import { AntDesign, Entypo } from '@expo/vector-icons'
import { DS } from '@/design-system'
import { Pressable } from 'react-native'
import { useRouter } from 'expo-router'

const startStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column'
  },
  image: {
    flex: 1,
    resizeMode: 'cover',
    justifyContent: 'center'
  },
  text: {
    color: 'white',
    fontSize: 42,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#000000a0'
  }
})

export const AdminMessagesScreen = observer(() => {
  const router = useRouter()
  const store = useStore()
  const unsortedMessages = store.messages.messages.slice()
  const messages = orderBy(
    uniqBy(unsortedMessages, (message) => message.payload.id),
    [(message) => message.payload.timestamp, (message) => message.payload.version],
    ['asc', 'asc']
  )

  const [visible, setVisible] = React.useState(false)
  const [message, setMessage] = React.useState('')
  const isMessageSortingEnabled = store.messages.isSortingMessageByTimestamp
  const showModal = () => setVisible(true)
  const hideModal = () => setVisible(false)
  const containerStyle = { backgroundColor: 'white', padding: 20 }
  // const showSnackbar = store.messages.showSnackbar

  const onToggleSwitch = debounce(() => {
    const toggleSorting = isMessageSortingEnabled
    store.messages.setIsSortingMessageByTimestamp(!toggleSorting)
  }, 250)

  return (
    <ImageBackground source={image} style={{ ...startStyles.image }}>
      <View style={{ backgroundColor: 'rgba(255,255,255,.9)', flex: 1 }}>
        <SafeAreaView style={styles.container}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 16 }}>
            <View style={{ flexDirection: 'row', gap: 8, justifyContent: 'center' }}>
              <Entypo name="message" size={24} color="black" />
              <DS.Text variant="Heading 3/Regular">Messages</DS.Text>
            </View>
            <Pressable onPress={() => router.back()} hitSlop={10}>
              <AntDesign name="close" size={24} color="black" />
            </Pressable>
          </View>

          <View style={{ flex: 1 }}>
            <List.Item
              title={translate('adminMessageScreen.toast')}
              description={translate('adminMessageScreen.showSnackbar')}
              // right={(props) => (
              //   <Switch value={showSnackbar} onValueChange={debounce(() => store.messages.toggleSnackbar(), 250)} />
              // )}
            />
            <List.Item
              title={translate('adminMessageScreen.sortMessage')}
              right={(props) => <Switch value={isMessageSortingEnabled} onValueChange={onToggleSwitch} />}
            />
            <FlatList
              data={isMessageSortingEnabled ? messages : unsortedMessages}
              keyExtractor={(item, index) => `message-item-${index}`}
              renderItem={({ item, index, separators }) => (
                <Menu.Item
                  key={`admin-menu-messages-${index}`}
                  // icon="content-paste"
                  onPress={debounce(() => {
                    const pretty = JSON.stringify(item, null, 2)
                    setMessage(pretty)
                    Clipboard.setString(pretty)
                    showModal()
                  }, 250)}
                  title={item.payload.kind ?? ''}
                />
              )}
            />
          </View>
          <Modal visible={visible} onDismiss={hideModal} contentContainerStyle={containerStyle}>
            <Text
              allowFontScaling={false}
              tx="adminMessageScreen.howToDismissMessage"
              style={{ color: 'black', textAlign: 'center' }}
            />
            <Text allowFontScaling={false}>{'\n'}</Text>
            <ScrollView>
              <Text allowFontScaling={false} style={{ color: 'black' }}>
                {message}
              </Text>
            </ScrollView>
          </Modal>
        </SafeAreaView>
      </View>
    </ImageBackground>
  )
})
